export class UserModal
{ 
     userName: string;
     password : string;
     email:string;
     name: string;
     nic : string;
}
